import { DotGrid } from '#app/components/dot-grid.tsx'
import { GradientBlob } from '#app/components/ui/decorative.tsx'
import { cn } from '#app/utils/misc.tsx'

/**
 * Marketing hero backdrop: dot grid plus two floating brand orbs.
 * Render as the first child of a `relative overflow-hidden` section.
 */
export function HeroBackdrop({ className }: { className?: string }) {
	return (
		<div className={cn('absolute inset-0', className)} aria-hidden="true">
			<DotGrid />
			<GradientBlob className="animate-float-orb-1 -top-32 -right-32 h-[500px] w-[500px]" />
			<GradientBlob className="animate-float-orb-2 -bottom-32 -left-32 h-[400px] w-[400px] opacity-15" />
		</div>
	)
}
